import { render, staticRenderFns } from "./VariantSelectorImageButton.vue?vue&type=template&id=a6285a46&"
import script from "./VariantSelectorImageButton.vue?vue&type=script&lang=ts&"
export * from "./VariantSelectorImageButton.vue?vue&type=script&lang=ts&"
import style0 from "./VariantSelectorImageButton.vue?vue&type=style&index=0&id=a6285a46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports